import { Component, EventEmitter, Input, Output, OnInit, Inject } from '@angular/core';
import { LiveChatService } from '../../../../src/lib/services/live-chat.service';
import { ModalType } from '@challenger6/vm-pattern-library/modal';
import { IconWeight } from '../../models/icon-weight.enum';
import { GenericTileModel, GenericTileType } from './generic-tile.model';
import { LIB_CONFIG } from '../../lib-config';
import { LibConfig } from '../../models/lib-config.model';
import { PriorityCallService } from '../../services/priority-call.service';
import { CareAnalyticsService } from '../../services/care-analytics.service';
import { LiveChatEvent } from '../../services/care-analytics.enum';

@Component({
  selector: 'vm-generic-tiles',
  templateUrl: './generic-tiles.component.html',
  styleUrls: ['./generic-tiles.component.scss'],
})
export class GenericTilesComponent implements OnInit {
  @Input() tiles: GenericTileModel[];
  @Input() tilesContainerHeading?: string;
  @Input() tilesContainerCopy?: string;
  @Input() chatbotId?: string = 'faultsbuttonnew';
  @Input() columnView?: string;
  @Input() type?: GenericTileType = GenericTileType.TILE_WITH_ICON;
  @Output() selected: EventEmitter<GenericTileModel> = new EventEmitter();
  public selectedTile: any;
  IconWeight = IconWeight;
  GenericTileType = GenericTileType;
  modalType = ModalType.Large;
  strapiUrl: string;

  constructor(
    public liveChatService: LiveChatService,
    @Inject(LIB_CONFIG) private config: LibConfig,
    public priorityCallService: PriorityCallService,
    private careAnalyticsService: CareAnalyticsService
  ) {
    this.strapiUrl = this.config.strapiURL;
  }

  ngOnInit(): void {
    setTimeout(() => {
      this.liveChatService.reloadLiveAgentMonitor();
    }, 500);
  }

  tileSelected(selectedTile) {
    this.tiles.forEach((tile) => {
      if (tile.title === selectedTile.title) {
        tile.isSelected = true;
      } else {
        tile.isSelected = false;
      }
    });
    this.selected.emit(selectedTile);
  }

  openChat(e) {
    this.careAnalyticsService.trackLiveChatEvent(LiveChatEvent.OPENED);
    e.preventDefault();
    return false;
  }

  openModal(tile) {
    this.priorityCallService.createPriorityCallMTD(tile);
    if (tile.uid === 'modal') {
      this.modalType = ModalType.Standard;
    }
    tile.isModalOpen = true;
    return false;
  }
}
